import { render, staticRenderFns } from "./SampleSchedules.vue?vue&type=template&id=bfe2fa1c&"
import script from "./SampleSchedules.vue?vue&type=script&lang=js&"
export * from "./SampleSchedules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports